export function hexToString(hex: string): string {
  if (!hex) return '';

  const matches = hex.match(/.{1,2}/g);
  if (!matches) return '';

  const bytes = new Uint8Array(matches.map((b) => parseInt(b, 16)));

  const result = new TextDecoder().decode(bytes);
  return result;
}
